module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/assets/bootstrap/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/bootstrap/fonts/glyphicons-halflings-regular.svg
// module chunks = styles